<template>
  <AppFlowTransition>
    <div v-if="showSteps">
      <div class="stepper">
        <div
          class="stepper-item"
          v-for="(blok, i) in steps"
          :key="i"
          :class="{ active: i < getStep + 1 }"
        >
          <span>{{ blok.ShortTitle }}</span>
        </div>
      </div>
    </div>
  </AppFlowTransition>
</template>
<script>
  import { mapState } from 'vuex';
  import AppFlowTransition from '@/components/base/AppFlowTransition';
  export default {
    components: {
      AppFlowTransition,
    },
    computed: {
      ...mapState(['pageData', 'newData']),
      steps() {
        return this.newData;
      },
      showSteps() {
        return (
          this.steps.length &&
          this.getStep > 0 &&
          this.getStep < this.steps.length - 1
        );
      },
      getStep() {
        let currentStep;
        this.steps.map((step, index) => {
          if (step.Slug === this.$route.params.step) {
            currentStep = index;
          }
        });
        return currentStep;
      },
    },
  };
</script>
<style lang="scss" scoped>
  $stepperwidth: 560px;
  $steppermargin: 30px;
  $steppermargin-sm: 20px;
  $stepmargin: 2px;
  $stepheight: 8px;
  .stepper {
    display: flex;
    flex-wrap: wrap;
    width: calc(100% - #{$steppermargin * 2});
    max-width: $stepperwidth;
    position: absolute;
    height: $stepheight;
    z-index: 10;
    right: $steppermargin;
    top: $steppermargin;
    @include media-breakpoint-down(sm) {
      width: calc(100% - #{$steppermargin-sm * 2});
      right: $steppermargin-sm;
      top: $steppermargin-sm;
    }
    &-item {
      content: '';
      height: $stepheight;
      flex: 1 auto;
      margin-right: $stepmargin;
      background-color: $blue10;
      position: relative;
      &:after {
        position: absolute;
        content: '';
        height: $stepheight;
        margin-right: $stepmargin;
        width: 0;
        background-color: $green;
        transition: 0.4s ease-in;
      }
      &:first-child {
        display: none;
      }
      &:last-child {
        display: none;
      }
      &.active:after {
        width: 100%;
      }
    }
  }
  span {
    position: absolute;
    top: 10px;
    font-size: 12px;
    color: $black;
    @include media-breakpoint-down(sm) {
      display: none;
    }
  }
</style>
